import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getLaunchUrl,
  listenForDeepLinks,
  mapDeepLinkToRoute,
  parseDeepLinkUrl,
} from '@/mobile/services/deepLink.service';
import { initPushService } from '@/mobile/services/push.service';

export function useDeepLinks() {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize native push notifications with navigation routing
    void initPushService({ navigate });

    const navigateFromUrl = (url: string) => {
      const path = parseDeepLinkUrl(url);
      if (!path) return;
      navigate(mapDeepLinkToRoute(path));
    };

    void getLaunchUrl().then((url) => {
      if (url) navigateFromUrl(url);
    });

    return listenForDeepLinks((path) => {
      navigate(path);
    });
  }, [navigate]);
}
